// assets
import { SwitchAccount, Notifications, Event, Devices, Storage } from '@mui/icons-material';

// constant
const icons = { SwitchAccount, Notifications, Event, Devices, Storage };

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const history = {
    id: 'history',
    title: 'History',
    type: 'group',
    authority: 'HISTORY_VIEW',
    children: [
        {
            id: 'accountHistory',
            title: 'Account',
            type: 'item',
            url: '/history/account',
            icon: icons.SwitchAccount
        },
        {
            id: 'pushHistory',
            title: 'Push',
            type: 'item',
            url: '/history/push',
            icon: icons.Notifications
        },
        {
            id: 'eventHistory',
            title: 'Event',
            type: 'item',
            url: '/history/event',
            icon: icons.Event
        },
        {
            id: 'platformHistory',
            title: 'Platform',
            type: 'item',
            url: '/history/platform',
            icon: icons.Devices
        },
        {
            id: 'storage',
            title: 'Storage',
            type: 'item',
            url: '/history/storage',
            icon: icons.Storage
        }
    ]
};

export default history;
